<!-- Truncated display-->
<div class="highlighted-topline highlighted-topline--age"
     *ngIf="truncate && topline?.appliedToplineValue">
<!-- Note, if a user only supplied an age, we may not have a date of birth-->
  <strong class="color--gray--005 txt-fw-500">
    <span *ngIf="topline?.appliedToplineValue.dateOfBirth">
      {{topline.appliedToplineValue.dateOfBirth | date:'MMM dd, yyyy'}}
    </span>
    <span *ngIf="topline?.appliedToplineValue.age">({{topline.appliedToplineValue.age}} Years Old)</span>
  </strong>
</div>

<div *ngIf="!truncate"
     class="toplines__pair toplines__pair--age col__ flexAlign--baseline"
     [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue?.age}">

  <div class="pair__icon">
    <i class="fal fa-fw fa-birthday-cake"
       matTooltip="Age"></i>
  </div>

  <div class="pair__content truncate">
    <span class="pair__label">Age</span>
    <span *ngIf="!topline?.appliedToplineValue?.age"
          (click)="onAddClicked()"
          class="pair__link link link--noline"
          data-test-id="toplineAddAddressLink">Add Date of Birth</span>
    <span *ngIf="topline?.appliedToplineValue?.age">{{topline?.appliedToplineValue?.age}}
      years old</span>
  </div>
</div>
